import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path d="M4 18h17v-6H4v6zM4 5v6h17V5H4z" />, 'ViewStream');
